module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am510-22b1e42c472ca718f51456b3a1dc0bda.jpg";